import { connect } from "react-redux";
import TableBodyComponent from "../../../Components/RecordingComponent/TableComponent/TableBodyComponent";
const mapStateToProps = (state) => ({
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableBodyComponent);
